var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg04ContinuousMonitoringandReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-6 {\n        fill: #f6f6e0;\n      }\n\n      .cls-7 {\n        fill: #00be84;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-9 {\n        fill: #f13624;\n      }\n\n      .cls-10 {\n        fill: #fff;\n      }\n\n      .cls-11 {\n        fill: #1860d3;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18 {\n        isolation: isolate;\n        opacity: .25;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-23 {\n        fill: #ffb62d;\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-25 {\n        fill: #e1f2fc;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.58,
    y: 32.67,
    width: 279.07,
    height: 163
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3571.23,
    y1: -4382.39,
    x2: 3646.14,
    y2: -4382.39,
    gradientTransform: "translate(1904.35 -5373.73) rotate(55.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b91f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c54e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3626.43,
    y1: -4523.63,
    x2: 3667.12,
    y2: -4523.63,
    gradientTransform: "translate(1904.35 -5373.73) rotate(55.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d35400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb62d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 8765.77,
    y1: -2779.74,
    x2: 8809.26,
    y2: -2779.74,
    gradientTransform: "translate(9031.06 -2668.59) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3dba85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1de885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 8742.41,
    y1: -2799.71,
    x2: 8813.77,
    y2: -2799.71,
    gradientTransform: "translate(9031.06 -2668.59) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05a1e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0562e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 8818.95,
    x2: 8862.09,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 8784.15,
    y1: -2819.67,
    x2: 8828.15,
    y2: -2819.67,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 8866.62,
    y1: -2799.71,
    x2: 8882.32,
    y2: -2799.71,
    gradientTransform: "translate(9031.06 -2668.59) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 8833.29,
    y1: -2819.67,
    x2: 8863.53,
    y2: -2819.67,
    gradientTransform: "translate(9031.06 -2668.59) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 8815.68,
    y1: -2779.74,
    x2: 8847.12,
    y2: -2779.74,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -2777.11,
    x2: -2730.92,
    gradientTransform: "translate(3048.46 -2668.59) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -2753.74,
    x2: -2730.92,
    gradientTransform: "translate(3048.46 -2668.59) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -2795.49,
    y1: -2819.67,
    x2: -2730.92,
    y2: -2819.67,
    gradientTransform: "translate(3048.46 -2668.59) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 8853.44,
    y1: -2779.29,
    x2: 8882.32,
    y2: -2779.29,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 8871.01,
    y1: -2819.67,
    x2: 8882.35,
    y2: -2819.67,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 113.88,
    y1: -2105.51,
    x2: 181.57,
    y2: -2105.51,
    gradientTransform: "translate(11.61 -2027.42) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 240,
    y1: -2235.51,
    x2: 240,
    y2: -2253.11,
    gradientTransform: "translate(0 -2039.03) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: -3.59,
    y: -3.39,
    width: 487.17,
    height: 226.77
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 89.58,
    y: 32.67,
    width: 279.07,
    height: 163
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M91.45,18.71h272.44c2.63,0,4.76,2.13,4.76,4.76h0v9.2H89.58v-12.09c0-1.03.84-1.87,1.88-1.87h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 360.71,
    cy: 25.69,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 350.32,
    cy: 25.69,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 339.93,
    cy: 25.69,
    r: 3.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M398.84,106.66l-9.86,9.23-1.64-1.29-4.73-3.74c-.11-.11-.28-.13-.41-.05-1.9,1-3.91,1.78-5.99,2.33-.2.03-.35.21-.36.41-.29,1.55-.58,3.1-.88,4.64-.2,1.07-.41,2.14-.62,3.25l-13.56-.53c0-.17-.04-.29-.06-.41-.36-2.5-.71-4.99-1.07-7.49,0-.17-.13-.32-.29-.36-2.02-.64-3.96-1.51-5.78-2.59-.11-.05-.23-.05-.34,0-1.46.96-2.92,1.94-4.37,2.91l-2.46,1.64-9.26-9.84c.05-.09.1-.17.16-.24,1.56-2.06,3.12-4.12,4.67-6.16.1-.1.12-.26.04-.38-.95-1.91-1.7-3.9-2.25-5.96-.02-.15-.15-.27-.3-.28l-4.38-.94-3.59-.78c.17-4.54.35-9.05.53-13.57l.49-.06,7.49-.95c.16,0,.3,0,.37-.23.62-2.07,1.5-4.04,2.63-5.88.05-.1.05-.22,0-.32-1.17-1.78-2.36-3.54-3.54-5.31-.34-.5-.67-1.01-1.01-1.51l9.84-9.27,2.21,1.73,4.03,3.17c.11.13.29.16.43.07,1.87-.97,3.84-1.72,5.88-2.24.18-.02.32-.17.33-.35.38-1.93.77-3.86,1.16-5.78.15-.75.3-1.5.44-2.19l13.49.41.04.3c.36,2.59.71,5.17,1.07,7.76,0,.17.12.33.29.37,1.96.65,3.85,1.49,5.64,2.53.2.14.47.13.65-.03,1.18-.81,2.38-1.6,3.56-2.4l3-2.02,9.31,9.89s-.03.02-.04.04c-1.59,2.1-3.18,4.19-4.77,6.29-.09.11-.09.27,0,.39,1,1.91,1.79,3.93,2.34,6.02.03.17.17.3.34.31,1.91.37,3.81.76,5.72,1.14l2.32.47c-.12,4.5-.24,8.98-.36,13.45l-.41.06-7.76,1.07c-.19,0-.35.13-.39.31-.64,2.01-1.5,3.94-2.57,5.75-.06.12-.06.26,0,.37.68,1.07,1.38,2.08,2.07,3.12l2.48,3.72ZM385.65,68.46c-8.82-9.39-23.58-9.85-32.97-1.03-9.39,8.82-9.85,23.58-1.03,32.97,8.75,9.31,23.67,9.79,32.93,1.07,9.41-8.73,9.96-23.45,1.23-32.86-.05-.06-.11-.11-.16-.17v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M290.54,207.77l-5.35,5.03-.89-.7-2.57-2.04c-.06-.06-.15-.08-.22-.03-1.03.54-2.12.96-3.25,1.26-.11.02-.19.11-.19.22-.16.84-.32,1.68-.48,2.52-.11.58-.22,1.17-.34,1.77l-7.37-.28c0-.09,0-.16-.03-.22-.19-1.36-.38-2.72-.57-4.08,0-.09-.07-.17-.16-.2-1.1-.35-2.15-.82-3.14-1.4-.06-.03-.13-.03-.19,0l-2.37,1.58-1.33.89-5.03-5.35.09-.13,2.54-3.34c.04-.06.04-.15,0-.21-.52-1.03-.93-2.12-1.23-3.24-.02-.08-.08-.14-.16-.15-.8-.17-1.6-.34-2.38-.53l-1.95-.42.28-7.37.27-.04,4.07-.53c.09,0,.17,0,.2-.12.34-1.12.82-2.19,1.43-3.18.03-.06.03-.12,0-.18-.64-.96-1.28-1.92-1.92-2.88-.19-.28-.37-.53-.53-.82l5.35-5.03,1.2.94,2.18,1.72c.07.06.13.1.24.04,1.02-.53,2.1-.94,3.21-1.21.1-.02.17-.09.18-.19.2-1.07.41-2.09.63-3.14l.24-1.19,7.32.22v.17c.2,1.4.39,2.81.58,4.21,0,.09.06.18.16.2,1.07.35,2.09.81,3.07,1.37.1.08.25.08.35,0,.64-.44,1.29-.87,1.94-1.3l1.6-1.1,5.06,5.35h0l-2.58,3.41c-.05.06-.05.15,0,.21.54,1.04.97,2.14,1.27,3.27.01.09.09.16.19.17l3.11.62,1.26.26-.2,7.3-.22.04-4.21.58c-.1,0-.18.07-.21.17-.35,1.09-.82,2.14-1.4,3.12-.03.06-.03.14,0,.2.37.57.75,1.13,1.12,1.7l1.35,2.09ZM283.39,187.03c-4.79-5.1-12.8-5.35-17.9-.56-5.1,4.79-5.35,12.8-.56,17.9,4.78,5.09,12.78,5.35,17.88.58,5.1-4.76,5.38-12.76.62-17.87-.02-.02-.04-.04-.06-.07l.02.02Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.8,
    y: 106.02,
    width: 43.49,
    height: 10.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 217.29,
    y: 125.99,
    width: 71.37,
    height: 10.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 168.97,
    y: 125.99,
    width: 43.14,
    height: 10.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 202.9,
    y: 145.95,
    width: 44.01,
    height: 10.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 148.74,
    y: 125.99,
    width: 15.69,
    height: 10.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 167.53,
    y: 145.75,
    width: 30.24,
    height: 10.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 183.93,
    y: 106.02,
    width: 31.45,
    height: 10.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 271.35,
    y: 106.02,
    width: 46.19,
    height: 10.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 294.72,
    y: 125.99,
    width: 22.82,
    height: 10.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 252.97,
    y: 145.95,
    width: 64.57,
    height: 10.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 148.74,
    y: 105.57,
    width: 28.87,
    height: 10.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 148.71,
    y: 145.95,
    width: 11.35,
    height: 10.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M149.58,81.4l21.67,32.8c2.2-1.47,4.25-3.15,6.12-5.02,15.4-15.4,15.51-40.61.28-55.86-15.24-15.25-40.45-15.12-55.85.28l27.79,27.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M149.58,81.4l-27.89,28.25c6.44,6.34,14.87,10.26,23.87,11.08,9.05.82,18.12-1.48,25.68-6.52l-21.66-32.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M149.58,81.4l-37.68-11.46c-4.39,13.94-.68,29.17,9.63,39.52l.53.53,27.52-28.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M149.58,81.4l-27.69-27.88-.1.1c-5.22,5.22-8.9,11.78-10.62,18.95l38.41,8.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "368.65 195.67 390.42 220 109.07 220 89.58 195.67 368.65 195.67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04ContinuousMonitoringandReporting);
export default __webpack_public_path__ + "static/media/04 Continuous Monitoring and Reporting.17d4543a80b93aa2308205aa8e361fe6.svg";
export { ForwardRef as ReactComponent };